import store from '@/store';
import i18n from '@/i18n';
import { AxiosResponse } from 'axios';

export class ErrorHandler {
  private static shared = new ErrorHandler();

  public static get instance() {
    return this.shared;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public async handleError(error: any) {
    // Do not open ErrorDialog in case of 409 error's status (conflict)
    if (error && error.response) {
      const response: AxiosResponse = error.response;

      if (response.status === 409) {
        return Promise.reject(error);
      }
    }

    console.error(error);

    await store.dispatch('notify/openInfoModal', {
      headline: i18n.t('global.dialogs.errorDialog.headline'),
      message: i18n.t('global.dialogs.errorDialog.message'),
      acceptCta: i18n.t('global.dialogs.errorDialog.acceptCta')
    });

    window.location.reload();
  }
}
